import { ApiError } from '../../api/client';

function codeOf(error: ApiError): string | undefined {
  return (error.body as { code?: string } | null)?.code;
}

/** Same 403/422/fallback idiom `arca-config-api-errors.ts` applies. */
function genericMessage(error: ApiError): string {
  if (error.status === 403) {
    return 'No tenés permiso para realizar esta acción.';
  }

  if (error.status === 422) {
    return 'Revisá los datos ingresados e intentá de nuevo.';
  }

  return 'Ocurrió un error inesperado. Intentá de nuevo.';
}

/** Codes from `EmailSettingsExceptionFilter` (`apps/api` `email-settings-exception.filter.ts`), `PUT /email-settings`. */
export function mapEmailSettingsError(error: unknown): string {
  if (!(error instanceof ApiError)) {
    return 'Ocurrió un error de conexión. Intentá de nuevo.';
  }

  const code = codeOf(error);

  if (error.status === 422 && code === 'EMAIL_PASSWORD_REQUIRED') {
    return 'Hace falta una contraseña: ingresá una para el usuario configurado.';
  }

  if (error.status === 409 && code === 'EMAIL_SECRETS_KEY_MISSING') {
    return 'No se puede guardar la contraseña porque falta la clave del servidor. Avisá a soporte.';
  }

  return genericMessage(error);
}

/** Codes from `EmailSettingsExceptionFilter`, `POST /email-settings/test`. SMTP failures arrive as `ok: false`, not here. */
export function mapEmailTestError(error: unknown): string {
  if (error instanceof ApiError) {
    const code = codeOf(error);

    if (error.status === 429 && code === 'EMAIL_TEST_RATE_LIMITED') {
      return 'Alcanzaste el límite de 5 pruebas por hora. Probá de nuevo más tarde.';
    }

    if (error.status === 409 && code === 'EMAIL_NOT_CONFIGURED') {
      return 'No hay nada para probar: guardá una configuración de correo antes de probar.';
    }
  }

  return mapEmailSettingsError(error);
}
